module.exports = __webpack_public_path__ + "static/img/weixin.1cf2cf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/home/weixin.jpg
// module id = B5Ah
// module chunks = 41